// ======================================================================
// File Name       : ContentDocumentContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import moment from 'moment';
import { Field, reduxForm, isInvalid, getFormValues, change } from 'redux-form';
import { connect } from 'react-redux';
import { Button, Form, Col } from 'react-bootstrap';
import EnterpriseNoticeRegisterEditForm from '../../components/enterpriseNotification/EnterpriseNoticeRegisterEditForm';
import DialogConfirm from '../../components/DialogConfirm';
import * as EnterpriseAction from '../../actions/EnterpriseAction';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { USE_DATE_RELEASE } from '../../constants/EnterpriseNoticeConstants';
import { VALIDATE_TYPE, RETURN_MAX_NUM, DEFAULT_DATE_FORMAT_SERVER, DEFAULT_DATE_SHORT_FORMAT_SERVER } from '../../constants/index';
import RenderField from '../../utils/ReduxFormUtils';
import Header from '../../components/Header';
import { ENTERPRISE_NOTIFICATION_LIST } from '../../constants/PathConstants';
import ModalConductor from '../../components/modal/ModalConductor';
import * as ModalIds from '../../constants/ModalIds';
import * as ModalAction from '../../actions/ModalAction';
import { hasProperty, parseDateForDetail } from '../../utils/index';

class EnterpriseNoticeEditContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noticeInfo: {
        noticeSecernId: null,
        noticeTitle: null,
        noticeContent: null,
        releaseTargetForEnterprise: 0,
        publicStatus: 1,
        publicDateFrom: moment().format(DEFAULT_DATE_SHORT_FORMAT_SERVER),
        publicDateTo: moment().add(1, 'month').format(DEFAULT_DATE_SHORT_FORMAT_SERVER),
        releasePeriod: USE_DATE_RELEASE.INDEFINITE_PERIOD,
      },
    };

    this.onConfirmDialogCancel = this.onConfirmDialogCancel.bind(this);
    this.onConfirmDialogOk = this.onConfirmDialogOk.bind(this);
    this.openConfirmDialog = this.openConfirmDialog.bind(this, MessageTemplate.BULK_EXPORT, null);
    this.getNoticeForEnterprise = this.getNoticeForEnterprise.bind(this);
    this.createParams = this.createParams.bind(this);
    this.goBack = this.goBack.bind(this);
    this.radioChange = this.radioChange.bind(this);
  }

  componentWillMount() {
    const { match } = this.props;
    this.getNoticeForEnterprise(match.params.id);
  }

  getNoticeForEnterprise(noticeForEnterpriseId) {
    if (noticeForEnterpriseId) {
      const param = this.createParams(noticeForEnterpriseId);
      this.props.dispatch(EnterpriseAction.getNoticeForEnterpriseDetail(param));
    }
  }

  createParams(noticeForEnterpriseSecernId) {
    const param = {
      selectTargetData: 0,
      searchInfo: {
        noticeList: [noticeForEnterpriseSecernId],
      },
    };
    return param;
  }

  goBack() {
    this.props.history.goBack();
  }

  openConfirmDialog() {
    this.props.dispatch(ModalAction.openModal(ModalIds.ENTERPRISE_NOTICE_CONFIRM));
  }

  /**
 * Action click cancel button in dialog
 */
  onConfirmDialogCancel() {
    this.setState({ showExportModal: false });
  }

  onConfirmDialogOk() {
    const { noticeInfo, history } = this.props;
    if (noticeInfo.releasePeriod === USE_DATE_RELEASE.INDEFINITE_PERIOD) {
      noticeInfo.publicDateFrom = '';
      noticeInfo.publicDateTo = '';
    }
    this.props.dispatch(EnterpriseAction.editNoticeForEnterprise(noticeInfo)).then(() => {
      this.setState({ showExportModal: false });
      history.push(ENTERPRISE_NOTIFICATION_LIST);
    });
  }

  radioChange(event, newValue, previousValue) {
    const { formValues } = this.props;
    if (formValues && Object.keys(formValues).length) {
      const nameTarget = event.target.name;
      if (hasProperty(formValues, nameTarget)) {
        const newFormValue = { ...formValues };
        let publicDateFromTemp = '';
        let publicDateToTemp = '';
        if (hasProperty(formValues, 'publicDateFrom')) {
          publicDateFromTemp = parseDateForDetail(formValues.publicDateFrom, 'YYYY/MM/DD', '');
        }
        if (hasProperty(formValues, 'publicDateTo')) {
          publicDateToTemp = parseDateForDetail(formValues.publicDateTo, 'YYYY/MM/DD', '');
        }
        if (newValue === 1 && previousValue === 0 && publicDateFromTemp === '' && publicDateToTemp === '') {
          newFormValue.publicDateFrom = moment();
          newFormValue.publicDateTo = moment().add(1, 'month');
        } else if (publicDateFromTemp !== '' && publicDateToTemp !== '') {
          newFormValue.publicDateFrom = formValues.publicDateFrom;
          newFormValue.publicDateTo = formValues.publicDateTo;
        }
        newFormValue.releasePeriod = newValue;
        this.props.dispatch(change('EnterpriseNoticeEdit', nameTarget, newFormValue));
        this.props.dispatch(change('EnterpriseNoticeEdit', 'publicDateFrom', newFormValue.publicDateFrom));
        this.props.dispatch(change('EnterpriseNoticeEdit', 'publicDateTo', newFormValue.publicDateTo));
      }
    }
  }

  render() {
    const { noticeInfo } = this.props;
    return (
      <div>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            this.openConfirmDialog();
          }}
          className='form-horizontal'
        >
          <Header name="企業向けお知らせ情報の編集" />
          <Col className="margin-top-10">
            編集する内容を指定してください
          </Col>
          <Col className="margin-top-10">
            <EnterpriseNoticeRegisterEditForm
              noticeTitle={noticeInfo.noticeTitle}
              noticeContent={noticeInfo.noticeContent}
              releasePeriod={noticeInfo.releasePeriod}
              releaseTargetForEnterprise={noticeInfo.releaseTargetForEnterprise}
              publicDateFrom={noticeInfo.publicDateFrom}
              publicDateTo={noticeInfo.publicDateTo}
              isEdit
              radioChange={this.radioChange}
            />
          </Col>
          <Col className="text-center margin-top-20">
            <Button variant="default" className="btn-96 margin-10" onClick={this.goBack}>
              キャンセル
            </Button>
            <Button variant="primary" className="btn-96 margin-10" type="submit" onClick={this.props.handleSubmit(this.openConfirmDialog)}>
              OK
            </Button>
          </Col>
          <ModalConductor history={this.props.history} isEdit />
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let { noticeInfo } = state.enterpriseNotice;
  const { EnterpriseNoticeEdit } = state.form;
  noticeInfo =
  EnterpriseNoticeEdit && EnterpriseNoticeEdit.values
    ? EnterpriseNoticeEdit.values
    : noticeInfo;
  return {
    ...{ noticeInfo },
    initialValues: noticeInfo,
    formValues: getFormValues('EnterpriseNoticeEdit')(state),
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'EnterpriseNoticeEdit', // a unique identifier for this form
    enableReinitialize: true,
  })(EnterpriseNoticeEditContainer),
);
